module.exports = __webpack_public_path__ + "img/mhes.05634b8a.png";